import sanityClient from "../client.js"
import { useState, useEffect } from "react"
import imageUrlBuilder from '@sanity/image-url'
import BlockContent from '@sanity/block-content-to-react'

import '../style/gallery.sass'
import '../style/spinner.sass'
import '../style/index.sass'
import Piece from "../comps/Piece.jsx"

const bg = require('../assets/dji/luroy.jpg')

const builder = imageUrlBuilder(sanityClient)
function urlFor(source) {
    return builder.image(source)
}

export default function Drone() {
    const [droneData, setDroneData] = useState(null)

    useEffect(() => {
        sanityClient
            .fetch(`*[_type == "drone"]{
                title,
                publishedAt,
                body,
                mainImage{
                    asset->{
                        _id,
                        url
                    },
                    alt
                }
            }`)
            .then((data) => {
                setDroneData(data)
            })
            .catch(console.error)
    }, [])

    return (
        <section className="drone gallery">
            <h1>Drone Shot Photos</h1>

            {!droneData && <div className="spinner"><div className="spinnerInner"></div></div>}
            <div className="single">
                {droneData && droneData.map(shot => (
                    <Piece picture={shot} shotFinished={'Taken '} />
                ))}
            </div>
        </section>
    )
}


